import React from "react";
import { useState } from "react";
import useStatusThunk from "../../hook/useStatusThunk";
import { resetPassword, sendPasswordReset } from "../../redux/ducks/session";
import DisplayError from "../dumb/DisplayError";
import LoadingButton from "../dumb/LoadingButton";
import TextInput from "../dumb/TextInput";

const ResetPassword = props => {
    const [screen, setScreen] = useState("getToken");
    const [userName, setUserName] = useState("");

    if (screen == "getToken") {
        return <GetTokenScreen userName={userName} setUserName={setUserName} onSuccess={e => setScreen("resetPassword")} />
    } else if (screen == "resetPassword") {
        return <ResetPasswordScreen userName={userName} onSuccess={props.onSuccess} />
    } else {
        return "";
    }
}

export default ResetPassword;

const GetTokenScreen = props => {
    const [d_sendResetPassword, status, error, e] = useStatusThunk(sendPasswordReset);

    e.onSuccess = () => props.onSuccess();

    return <div>
        <div className="group">
            <div className="label" name="userName">Username</div>
            <TextInput set={props.setUserName} v={props.userName} />
        </div>

        <div className="group">
            <DisplayError error={error} />
        </div>

        <LoadingButton loading={status == "pending"} onClick={e => d_sendResetPassword({ userName: props.userName })} className="button--primary login__button">
            Get code
        </LoadingButton>
    </div>
}

const ResetPasswordScreen = props => {
    const [d_resetPassword, status, error, e] = useStatusThunk(resetPassword);
    const [password, setPassword] = useState("");
    const [token, setToken] = useState("");

    e.onSuccess = () => props.onSuccess();

    return <div>

        <div className="group">
            <div className="label" name="userName">Username</div>
            <div>{props.userName}</div>
        </div>

        <div className="group">
            <div className="label" name="userName">Token (emailed)</div>
            <TextInput v={token} set={setToken} />
        </div>

        <div className="group">
            <div className="label" name="userName">Password</div>
            <TextInput v={password} set={setPassword} />
        </div>

        <div className="group">
            <DisplayError error={error} />
        </div>

        <LoadingButton loading={status == "pending"} onClick={e => d_resetPassword({ password, token })} className="button--primary login__button">
            Reset Password
        </LoadingButton>
    </div>
}